module.exports = __webpack_public_path__ + "img/2.18ccf0aa.png";